export const mockEmployeeData = [
  {
    uuid: "emp-001",
    organization_uuid: "org-001",
    employee_id: "EMP-1001",
    first_name: "Rajesh",
    last_name: "Sharma",
    email: "rajesh.sharma@acmeenterprise.com",
    phone: "+919876500001",
    profile_image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150",
    department: "Engineering",
    designation: "VP of Engineering",
    employment_type: "Full Time",
    location: "Bengaluru, India",
    joining_date: "2025-08-15",
    status: "Confirmed",
    manager_uuid: null,
    created_at: "2025-08-15T09:00:00.000Z",
    updated_at: "2025-08-15T09:00:00.000Z"
  },
  {
    uuid: "emp-002",
    organization_uuid: "org-001",
    employee_id: "EMP-1002",
    first_name: "Priya",
    last_name: "Patel",
    email: "priya.patel@acmeenterprise.com",
    phone: "+919876500002",
    profile_image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150",
    department: "Engineering",
    designation: "Software Engineer",
    employment_type: "Full Time",
    location: "Mumbai, India",
    joining_date: "2025-09-01",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2025-09-01T09:00:00.000Z",
    updated_at: "2025-09-01T09:00:00.000Z"
  },
  {
    uuid: "emp-003",
    organization_uuid: "org-001",
    employee_id: "EMP-1003",
    first_name: "Amit",
    last_name: "Verma",
    email: "amit.verma@acmeenterprise.com",
    phone: "+919876500003",
    profile_image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150",
    department: "Engineering",
    designation: "Software Engineer",
    employment_type: "Full Time",
    location: "Pune, India",
    joining_date: "2025-10-10",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2025-10-10T09:00:00.000Z",
    updated_at: "2025-10-10T09:00:00.000Z"
  },
  {
    uuid: "emp-004",
    organization_uuid: "org-001",
    employee_id: "EMP-1004",
    first_name: "Ananya",
    last_name: "Rao",
    email: "ananya.rao@acmeenterprise.com",
    phone: "+919876500004",
    profile_image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150",
    department: "Engineering",
    designation: "Software Engineer",
    employment_type: "Full Time",
    location: "Hyderabad, India",
    joining_date: "2025-11-01",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2025-11-01T09:00:00.000Z",
    updated_at: "2025-11-01T09:00:00.000Z"
  },
  {
    uuid: "emp-005",
    organization_uuid: "org-001",
    employee_id: "EMP-1005",
    first_name: "Vikram",
    last_name: "Singh",
    email: "vikram.singh@acmeenterprise.com",
    phone: "+919876500005",
    profile_image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150",
    department: "Engineering",
    designation: "Software Engineer",
    employment_type: "Full Time",
    location: "Gurugram, India",
    joining_date: "2025-12-05",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2025-12-05T09:00:00.000Z",
    updated_at: "2025-12-05T09:00:00.000Z"
  },
  {
    uuid: "emp-006",
    organization_uuid: "org-001",
    employee_id: "EMP-1006",
    first_name: "Sneha",
    last_name: "Kulkarni",
    email: "sneha.kulkarni@acmeenterprise.com",
    phone: "+919876500006",
    profile_image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150",
    department: "Engineering",
    designation: "Software Engineer",
    employment_type: "Full Time",
    location: "Bengaluru, India",
    joining_date: "2026-01-12",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2026-01-12T09:00:00.000Z",
    updated_at: "2026-01-12T09:00:00.000Z"
  },
  {
    uuid: "emp-007",
    organization_uuid: "org-001",
    employee_id: "EMP-1007",
    first_name: "Rohan",
    last_name: "Mehta",
    email: "rohan.mehta@acmeenterprise.com",
    phone: "+919876500007",
    profile_image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150",
    department: "Engineering",
    designation: "Software Engineer",
    employment_type: "Full Time",
    location: "Mumbai, India",
    joining_date: "2026-02-01",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2026-02-01T09:00:00.000Z",
    updated_at: "2026-02-01T09:00:00.000Z"
  },
  {
    uuid: "emp-008",
    organization_uuid: "org-001",
    employee_id: "EMP-1008",
    first_name: "Kavya",
    last_name: "Nair",
    email: "kavya.nair@acmeenterprise.com",
    phone: "+919876500008",
    profile_image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150",
    department: "Engineering",
    designation: "Software Engineer",
    employment_type: "Full Time",
    location: "Pune, India",
    joining_date: "2026-02-20",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2026-02-20T09:00:00.000Z",
    updated_at: "2026-02-20T09:00:00.000Z"
  },
  {
    uuid: "emp-009",
    organization_uuid: "org-001",
    employee_id: "EMP-1009",
    first_name: "Sanjay",
    last_name: "Gupta",
    email: "sanjay.gupta@acmeenterprise.com",
    phone: "+919876500009",
    profile_image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150",
    department: "Sales",
    designation: "Sales Manager",
    employment_type: "Full Time",
    location: "Hyderabad, India",
    joining_date: "2026-03-05",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2026-03-05T09:00:00.000Z",
    updated_at: "2026-03-05T09:00:00.000Z"
  },
  {
    uuid: "emp-010",
    organization_uuid: "org-001",
    employee_id: "EMP-1010",
    first_name: "Pooja",
    last_name: "Reddy",
    email: "pooja.reddy@acmeenterprise.com",
    phone: "+919876500010",
    profile_image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=150",
    department: "Sales",
    designation: "Sales Executive",
    employment_type: "Full Time",
    location: "Gurugram, India",
    joining_date: "2026-03-18",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2026-03-18T09:00:00.000Z",
    updated_at: "2026-03-18T09:00:00.000Z"
  },
  {
    uuid: "emp-011",
    organization_uuid: "org-001",
    employee_id: "EMP-1011",
    first_name: "Arjun",
    last_name: "Joshi",
    email: "arjun.joshi@acmeenterprise.com",
    phone: "+919876500011",
    profile_image: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=150",
    department: "Sales",
    designation: "Sales Executive",
    employment_type: "Full Time",
    location: "Bengaluru, India",
    joining_date: "2026-04-01",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2026-04-01T09:00:00.000Z",
    updated_at: "2026-04-01T09:00:00.000Z"
  },
  {
    uuid: "emp-012",
    organization_uuid: "org-001",
    employee_id: "EMP-1012",
    first_name: "Neha",
    last_name: "Deshmukh",
    email: "neha.deshmukh@acmeenterprise.com",
    phone: "+919876500012",
    profile_image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150",
    department: "Sales",
    designation: "Sales Executive",
    employment_type: "Full Time",
    location: "Mumbai, India",
    joining_date: "2026-04-15",
    status: "Confirmed",
    manager_uuid: "emp-001",
    created_at: "2026-04-15T09:00:00.000Z",
    updated_at: "2026-04-15T09:00:00.000Z"
  },
  {
    uuid: "emp-013",
    organization_uuid: "org-001",
    employee_id: "EMP-1013",
    first_name: "Siddharth",
    last_name: "Chopra",
    email: "siddharth.chopra@acmeenterprise.com",
    phone: "+919876500013",
    profile_image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=150",
    department: "Sales",
    designation: "Sales Executive",
    employment_type: "Full Time",
    location: "Pune, India",
    joining_date: "2026-05-02",
    status: "Probation",
    manager_uuid: "emp-001",
    created_at: "2026-05-02T09:00:00.000Z",
    updated_at: "2026-05-02T09:00:00.000Z"
  },
  {
    uuid: "emp-014",
    organization_uuid: "org-001",
    employee_id: "EMP-1014",
    first_name: "Divya",
    last_name: "Iyer",
    email: "divya.iyer@acmeenterprise.com",
    phone: "+919876500014",
    profile_image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150",
    department: "HR",
    designation: "HR Manager",
    employment_type: "Full Time",
    location: "Hyderabad, India",
    joining_date: "2026-05-10",
    status: "Probation",
    manager_uuid: "emp-001",
    created_at: "2026-05-10T09:00:00.000Z",
    updated_at: "2026-05-10T09:00:00.000Z"
  },
  {
    uuid: "emp-015",
    organization_uuid: "org-001",
    employee_id: "EMP-1015",
    first_name: "Karan",
    last_name: "Malhotra",
    email: "karan.malhotra@acmeenterprise.com",
    phone: "+919876500015",
    profile_image: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=150",
    department: "HR",
    designation: "HR Specialist",
    employment_type: "Full Time",
    location: "Gurugram, India",
    joining_date: "2026-05-20",
    status: "Probation",
    manager_uuid: "emp-001",
    created_at: "2026-05-20T09:00:00.000Z",
    updated_at: "2026-05-20T09:00:00.000Z"
  },
  {
    uuid: "emp-016",
    organization_uuid: "org-001",
    employee_id: "EMP-1016",
    first_name: "Ritu",
    last_name: "Saxena",
    email: "ritu.saxena@acmeenterprise.com",
    phone: "+919876500016",
    profile_image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=150",
    department: "HR",
    designation: "HR Specialist",
    employment_type: "Full Time",
    location: "Bengaluru, India",
    joining_date: "2026-06-10",
    status: "Probation",
    manager_uuid: "emp-001",
    created_at: "2026-06-10T09:00:00.000Z",
    updated_at: "2026-06-10T09:00:00.000Z"
  },
  {
    uuid: "emp-017",
    organization_uuid: "org-001",
    employee_id: "EMP-1017",
    first_name: "Alok",
    last_name: "Kumar",
    email: "alok.kumar@acmeenterprise.com",
    phone: "+919876500017",
    profile_image: "https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?w=150",
    department: "HR",
    designation: "HR Specialist",
    employment_type: "Full Time",
    location: "Mumbai, India",
    joining_date: "2026-06-15",
    status: "Probation",
    manager_uuid: "emp-001",
    created_at: "2026-06-15T09:00:00.000Z",
    updated_at: "2026-06-15T09:00:00.000Z"
  },
  {
    uuid: "emp-018",
    organization_uuid: "org-001",
    employee_id: "EMP-1018",
    first_name: "Tanvi",
    last_name: "Bhasin",
    email: "tanvi.bhasin@acmeenterprise.com",
    phone: "+919876500018",
    profile_image: "https://images.unsplash.com/photo-1548142813-c348350df52b?w=150",
    department: "Finance",
    designation: "Finance Manager",
    employment_type: "Full Time",
    location: "Pune, India",
    joining_date: "2026-06-20",
    status: "Notice Period",
    manager_uuid: "emp-001",
    created_at: "2026-06-20T09:00:00.000Z",
    updated_at: "2026-06-20T09:00:00.000Z"
  },
  {
    uuid: "emp-019",
    organization_uuid: "org-001",
    employee_id: "EMP-1019",
    first_name: "Gaurav",
    last_name: "Pandey",
    email: "gaurav.pandey@acmeenterprise.com",
    phone: "+919876500019",
    profile_image: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=150",
    department: "Finance",
    designation: "Financial Analyst",
    employment_type: "Full Time",
    location: "Hyderabad, India",
    joining_date: "2026-06-25",
    status: "Notice Period",
    manager_uuid: "emp-001",
    created_at: "2026-06-25T09:00:00.000Z",
    updated_at: "2026-06-25T09:00:00.000Z"
  },
  {
    uuid: "emp-020",
    organization_uuid: "org-001",
    employee_id: "EMP-1020",
    first_name: "Ishita",
    last_name: "Roy",
    email: "ishita.roy@acmeenterprise.com",
    phone: "+919876500020",
    profile_image: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=150",
    department: "Finance",
    designation: "Financial Analyst",
    employment_type: "Full Time",
    location: "Gurugram, India",
    joining_date: "2026-07-01",
    status: "Notice Period",
    manager_uuid: "emp-001",
    created_at: "2026-07-01T09:00:00.000Z",
    updated_at: "2026-07-01T09:00:00.000Z"
  },
  {
    uuid: "emp-021",
    organization_uuid: "org-001",
    employee_id: "EMP-1021",
    first_name: "Manish",
    last_name: "Tiwari",
    email: "manish.tiwari@acmeenterprise.com",
    phone: "+919876500021",
    profile_image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150",
    department: "Marketing",
    designation: "Marketing Director",
    employment_type: "Full Time",
    location: "Bengaluru, India",
    joining_date: "2026-07-05",
    status: "Resigned",
    manager_uuid: "emp-001",
    created_at: "2026-07-05T09:00:00.000Z",
    updated_at: "2026-07-05T09:00:00.000Z"
  },
  {
    uuid: "emp-022",
    organization_uuid: "org-001",
    employee_id: "EMP-1022",
    first_name: "Shweta",
    last_name: "Bhatt",
    email: "shweta.bhatt@acmeenterprise.com",
    phone: "+919876500022",
    profile_image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150",
    department: "Marketing",
    designation: "Marketing Strategist",
    employment_type: "Full Time",
    location: "Mumbai, India",
    joining_date: "2026-07-10",
    status: "Resigned",
    manager_uuid: "emp-001",
    created_at: "2026-07-10T09:00:00.000Z",
    updated_at: "2026-07-10T09:00:00.000Z"
  },
  {
    uuid: "emp-023",
    organization_uuid: "org-001",
    employee_id: "EMP-1023",
    first_name: "Nikhil",
    last_name: "Bansal",
    email: "nikhil.bansal@acmeenterprise.com",
    phone: "+919876500023",
    profile_image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150",
    department: "Marketing",
    designation: "Marketing Strategist",
    employment_type: "Full Time",
    location: "Pune, India",
    joining_date: "2026-07-15",
    status: "Resigned",
    manager_uuid: "emp-001",
    created_at: "2026-07-15T09:00:00.000Z",
    updated_at: "2026-07-15T09:00:00.000Z"
  },
  {
    uuid: "emp-024",
    organization_uuid: "org-001",
    employee_id: "EMP-1024",
    first_name: "Meera",
    last_name: "Sen",
    email: "meera.sen@acmeenterprise.com",
    phone: "+919876500024",
    profile_image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150",
    department: "Operations",
    designation: "Operations Manager",
    employment_type: "Full Time",
    location: "Hyderabad, India",
    joining_date: "2026-07-20",
    status: "Terminated",
    manager_uuid: "emp-001",
    created_at: "2026-07-20T09:00:00.000Z",
    updated_at: "2026-07-20T09:00:00.000Z"
  },
  {
    uuid: "emp-025",
    organization_uuid: "org-001",
    employee_id: "EMP-1025",
    first_name: "Abhishek",
    last_name: "Mishra",
    email: "abhishek.mishra@acmeenterprise.com",
    phone: "+919876500025",
    profile_image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150",
    department: "Operations",
    designation: "Operations Associate",
    employment_type: "Full Time",
    location: "Gurugram, India",
    joining_date: "2026-07-25",
    status: "Terminated",
    manager_uuid: "emp-001",
    created_at: "2026-07-25T09:00:00.000Z",
    updated_at: "2026-07-25T09:00:00.000Z"
  },
  {
    uuid: "emp-026",
    organization_uuid: "org-001",
    employee_id: "EMP-1026",
    first_name: "Aarti",
    last_name: "Agarwal",
    email: "aarti.agarwal@acmeenterprise.com",
    phone: "+919876500026",
    profile_image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150",
    department: "Operations",
    designation: "Operations Associate",
    employment_type: "Full Time",
    location: "Bengaluru, India",
    joining_date: "2026-08-01",
    status: "Retired",
    manager_uuid: "emp-001",
    created_at: "2026-08-01T09:00:00.000Z",
    updated_at: "2026-08-01T09:00:00.000Z"
  },
  {
    uuid: "emp-027",
    organization_uuid: "org-001",
    employee_id: "EMP-1027",
    first_name: "Varun",
    last_name: "Kapoor",
    email: "varun.kapoor@acmeenterprise.com",
    phone: "+919876500027",
    profile_image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150",
    department: "Support",
    designation: "Support Specialist",
    employment_type: "Full Time",
    location: "Mumbai, India",
    joining_date: "2026-08-02",
    status: "Retired",
    manager_uuid: "emp-001",
    created_at: "2026-08-02T09:00:00.000Z",
    updated_at: "2026-08-02T09:00:00.000Z"
  },
  {
    uuid: "emp-028",
    organization_uuid: "org-001",
    employee_id: "EMP-1028",
    first_name: "Nisha",
    last_name: "Dutta",
    email: "nisha.dutta@acmeenterprise.com",
    phone: "+919876500028",
    profile_image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150",
    department: "Support",
    designation: "Support Specialist",
    employment_type: "Full Time",
    location: "Pune, India",
    joining_date: "2026-08-03",
    status: "Joined (This Month)",
    manager_uuid: "emp-001",
    created_at: "2026-08-03T09:00:00.000Z",
    updated_at: "2026-08-03T09:00:00.000Z"
  },
  {
    uuid: "emp-029",
    organization_uuid: "org-001",
    employee_id: "EMP-1029",
    first_name: "Tarun",
    last_name: "Jain",
    email: "tarun.jain@acmeenterprise.com",
    phone: "+919876500029",
    profile_image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150",
    department: "Design",
    designation: "UI/UX Designer",
    employment_type: "Full Time",
    location: "Hyderabad, India",
    joining_date: "2026-08-04",
    status: "Joined (This Month)",
    manager_uuid: "emp-001",
    created_at: "2026-08-04T09:00:00.000Z",
    updated_at: "2026-08-04T09:00:00.000Z"
  },
  {
    uuid: "emp-030",
    organization_uuid: "org-001",
    employee_id: "EMP-1030",
    first_name: "Swati",
    last_name: "Chawla",
    email: "swati.chawla@acmeenterprise.com",
    phone: "+919876500030",
    profile_image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=150",
    department: "Design",
    designation: "UI/UX Designer",
    employment_type: "Full Time",
    location: "Gurugram, India",
    joining_date: "2026-08-05",
    status: "Joined (This Month)",
    manager_uuid: "emp-001",
    created_at: "2026-08-05T09:00:00.000Z",
    updated_at: "2026-08-05T09:00:00.000Z"
  }
];